import { ActionTypes } from "../constants/action-types";

const initialState = {
  imageData: [],
  loading: false,
  error: null
};

const CollaborationImageReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_COLLABORATION_IMAGE:
      return {
        ...state,
        imageData: action.payload,
        loading: false,
        error: null
      };

    case "UPDATE_COLLABORATOR_REQUEST":
      return {
        ...state,
        loading: true,
        error: null
      };

    case "UPDATE_COLLABORATOR_SUCCESS":
      const updatedData = state.imageData.map(item =>
        item.collaboration_id === action.payload.collaboration_id
          ? {
              ...item,
              organizationName: action.payload.organizationName,
              startdate: action.payload.startdate,
              enddate: action.payload.enddate,
              image_url: action.payload.image_url || item.image_url
            }
          : item
      );
      
      console.log("Updated state:", {
        loading: false,
        imageData: updatedData,
        error: null
      });
      
      return {
        ...state,
        loading: false,
        imageData: updatedData,
        error: null
      };

    case "UPDATE_COLLABORATOR_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default CollaborationImageReducer;
